export const useTracking = () => {
  const { api } = useApi();
  const authState = useAuthState();

  const getCookie = (name) => {
    let cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      let [key, value] = cookies[i].split("=");
      if (key === name) return decodeURIComponent(value);
    }
    return null;
  };

  const setCookie = (cookieName, value, days, domain) => {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + days);
    var cookieValue =
      encodeURIComponent(value) +
      (days == null ? "" : ";expires=" + exdate.toUTCString()) +
      ";path=/" +
      (domain ? ";domain=" + domain : "");
    document.cookie = cookieName + "=" + cookieValue;
  };

  const uuidv4 = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };

  // 트래킹은 부가 기능이므로, 실패해도 호출부(로그인/화면 이동)를 막지 않는다.
  const createTracking = (eventId, page, action) => {
    try {
      createTrackingInternal(eventId, page, action);
    } catch (error) {
      console.error("createTracking error:", error);
    }
  };

  const createTrackingInternal = (eventId, page, action) => {
    let gtagId = "";
    let tempId = "";
    let userId = "";
    let obtagId = "";

    tempId = getCookie("_ga");
    if (tempId != null) {
      gtagId = tempId;
      userId = gtagId;
    } else {
      tempId = getCookie("_ob");
      if (tempId == null) {
        if (obtagId == null) {
          obtagId = "OB1." + uuidv4();
          setCookie("_ob", obtagId, 90);
        }
      } else {
        obtagId = tempId;
      }
      userId = obtagId;
    }

    const reqParam = {
      eventId,
      page,
      action,
      utmMedium: localStorage.getItem("utm_medium") || "",
      utmSource: localStorage.getItem("utm_source") || "",
      keyword: JSON.parse(localStorage.getItem("keyword") || "{}"),
      gtagId      
    };

    api("/api/tracking/createTracking", reqParam);
  };

  return { createTracking };
};